import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var Export = function Export(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '16 5 20 21' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.625,8.13375 L29.933125,11.441875 C30.055,11.56375 30.215,11.625 30.375,11.625 C30.535,11.625 30.695,11.56375 30.816875,11.441875 C31.06125,11.1975 31.06125,10.8025 30.816875,10.558125 L26.441875,6.183125 C26.1975,5.93875 25.8025,5.93875 25.558125,6.183125 L21.183125,10.558125 C20.93875,10.8025 20.93875,11.1975 21.183125,11.441875 C21.4275,11.68625 21.8225,11.68625 22.066875,11.441875 L25.375,8.13375 L25.375,20.375 C25.375,20.720625 25.655,21 26,21 C26.345,21 26.625,20.720625 26.625,20.375 L26.625,8.13375 Z M17.560625,26 C16.7,26 16,25.3 16,24.439375 L16,16 C16,15.655 16.28,15.375 16.625,15.375 C16.97,15.375 17.25,15.655 17.25,16 L17.25,24.439375 C17.25,24.610625 17.389375,24.75 17.560625,24.75 L34.439375,24.75 C34.610625,24.75 34.75,24.610625 34.75,24.439375 L34.75,16 C34.75,15.655 35.029375,15.375 35.375,15.375 C35.720625,15.375 36,15.655 36,16 L36,24.439375 C36,25.3 35.3,26 34.439375,26 L17.560625,26 Z"
  }));
};

Export.displayName = 'Export';
export default Export;